// extracted by css-extract-rspack-plugin
export default {"root":"YcpServiceAlert_root___bSnf"};